module.exports = __webpack_public_path__ + "static/img/zhihuiyanglao.199752b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/zhihuiyanglao.png
// module id = 4WTM
// module chunks = 0